import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { columns } from './constants';
import { config } from '../../../../config/envs';
import { jdsTableStyles } from '../../../components/jds/tableStyles';
import { JdsPagination } from '../../../components/jds/JdsPagination';

export default function BenefitsTable({
  cliente_id,
  path,
  errorMessage = 'Ocorreu um erro ao carregar os benefícios.',
  refreshKey = 0,
}) {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchBenefits = useCallback(
    async (page = 1) => {
      setLoading(true);
      try {
        const response = await axios.get(
          config.app.adminBaseUrl +
            `${path}?clientId=${cliente_id}&itemsPerPage=${perPage}&page=${page}`,
        );
        setBenefits(response.data?.data?.benefits || []);
        setTotalRows(response.data?.data?.totalItems || 0);
      } catch (err) {
        toast.error(errorMessage);
      }
      setLoading(false);
    },
    [path, perPage, cliente_id, errorMessage],
  );

  const handlePageChange = (page) => {
    fetchBenefits(page);
  };

  useEffect(() => {
    fetchBenefits(1);
  }, [fetchBenefits, refreshKey]);

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <DataTable
        columns={columns}
        data={benefits}
        customStyles={jdsTableStyles}
        paginationComponent={JdsPagination}
        responsive={false}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        paginationPerPage={perPage}
        onChangeRowsPerPage={(newPerPage) => setPerPage(newPerPage)}
      />
    </div>
  );
}
